import {
  ATENCIONSINTURNO_SUCCESS,
  ATENCIONSINTURNO_LOADING,
  ATENCIONSINTURNO_ERROR,
  ATENCIONSINTURNO_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import atencionSinTurnoInitialState from "../initialStates/atencionSinTurnoInitialState";

const atencionSinTurno = (state, { payload, type }) => {
  switch (type) {
    case ATENCIONSINTURNO_LOADING:
      return {
        ...state,
        atencionSinTurno: {
          ...state.atencionSinTurno,
          error: false,
          loading: true,
        },
      };
    case ATENCIONSINTURNO_SUCCESS:
      return {
        ...state,
        atencionSinTurno: {
          ...state.atencionSinTurno,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case ATENCIONSINTURNO_ERROR:
      return {
        ...state,
        atencionSinTurno: {
          ...state.atencionSinTurno,
          error: payload,
          loading: false,
        },
      };

    case ATENCIONSINTURNO_RESET:
      return atencionSinTurnoInitialState;
    case RESET_PORTAL_CONTEXT:
      return atencionSinTurnoInitialState;

    default:
      return state;
  }
};

export default atencionSinTurno;
